var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v73.471h512v-73.471 C512,105.443,494.833,88.276,473.655,88.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345 v-73.471H0V385.379z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 200.09,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 111.81
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M361.945,256.098c0,58.426-47.434,105.945-105.945,105.945s-105.945-47.519-105.945-105.945 c0-58.595,47.435-106.029,105.945-106.029S361.945,197.503,361.945,256.098L361.945,256.098z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2DD30"
    },
    d: "M175.42,229.463h61.556l13.929-42.867l3.699,11.498l-20.227,62.316l-6.026-4.396l6.301-19.362 h-49.506L175.42,229.463z M206.176,324.247l19.025-58.51l-36.462-26.55h12.026l52.995,38.473l-6.024,4.396l-16.509-12.007 l-15.325,47.181L206.176,324.247L206.176,324.247z M305.822,324.247L256,288.061l-36.442,26.464l3.721-11.329l52.952-38.558 l2.262,7.102l-16.468,11.923l40.057,29.172L305.822,324.247L305.822,324.247z M336.578,229.463l-49.781,36.274l13.931,42.869 l-9.724-7.104l-20.209-62.316h7.399l6.298,19.448l40.079-29.172h12.006v0.001H336.578z M256,170.953l19.025,58.51h45.088 l-9.745,7.189h-65.487l2.305-7.189h20.418l-15.326-47.096L256,170.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2DD30"
    },
    d: "M257.775,340.822h-3.53V294.91h3.53V340.822L257.775,340.822z M336.051,283.831l-43.651-14.12 l1.099-3.297l43.672,14.12L336.051,283.831L336.051,283.831z M175.928,283.831l-1.1-3.297l43.692-14.12l1.08,3.297L175.928,283.831 L175.928,283.831z M280.289,225.658l-2.877-2.028l26.995-37.12l2.812,2.03L280.289,225.658L280.289,225.658z M231.776,225.658 l-27.038-37.118l2.855-2.03l26.973,37.12L231.776,225.658L231.776,225.658z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt);
export default __webpack_public_path__ + "static/media/et.a3d93de2a2f42d06694c0e10c3971017.svg";
export { ForwardRef as ReactComponent };